<template>
  <div class="bbp-loader-background"
       :class="{'bbp-loader-background_block': blockMode}">
    <div class="bbp-loader">
      <div class="bbp-loader__face">
        <div class="bbp-loader__circle"></div>
      </div>
      <div class="bbp-loader__face">
        <div class="bbp-loader__circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPLoader',
  props: ['blockMode'],
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/transition";

  .bbp-loader {
    width: 40px;
    height: 40px;
    font-size: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &-background {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99999;
      width: 100%;
      height: 100%;
      background-color: rgba($color-accent, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;

      &_block {
        position: absolute;
        background-color: $color-white;

        .bbp-loader {
          &__face {
            &:nth-child(1) {
              color: $color-accent;
            }

            &:nth-child(2) {
              color: $color-accent;
            }
          }

          &__circle {
            &::before {
              box-shadow: 0 0 2em,
              0 0 3em,
              0 0 4em,
              0 0 5em,
              0 0 6em,
              0 0 0 0.5em rgba($color-accent, 0.05);
            }
          }
        }
      }
    }

    &__face {
      position: absolute;
      border-radius: 50%;
      border-style: solid;
      animation: animate-loader-fly 1s linear infinite;

      &:nth-child(1) {
        width: 100%;
        height: 100%;
        color: $color-white;
        border-color: currentColor transparent transparent currentColor;
        border-width: 0.2em 0.2em 0 0;
        --deg: -45deg;
        animation-direction: normal;
        animation-duration: 1s;
      }

      &:nth-child(2) {
        width: 65%;
        height: 65%;
        color: $color-white;
        border-color: currentColor currentColor transparent transparent;
        border-width: 0.2em 0 0 0.2em;
        --deg: -135deg;
        animation-direction: reverse;
        animation-duration: 1s;
      }

    }

    &__circle {
      position: absolute;
      width: 50%;
      height: 0.1em;
      top: 50%;
      left: 50%;
      background-color: transparent;
      transform: rotate(var(--deg));
      transform-origin: left;

      &::before {
        position: absolute;
        top: -0.5em;
        right: -0.5em;
        content: '';
        width: 0.8em;
        height: 0.8em;
        background-color: currentColor;
        border-radius: 50%;
        box-shadow: 0 0 2em,
        0 0 3em,
        0 0 4em,
        0 0 5em,
        0 0 6em,
        0 0 0 0.5em rgba($color-white, 0.1);
      }
    }
  }

  @keyframes animate-loader-fly {
    to {
      transform: rotate(1turn);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPLoader/BBPLoader.vue